export const adminRoutes = {
  root: '/admin',
};
